import React from "react";
import { useSelector, shallowEqual } from "react-redux";
import { makeStyles } from "@material-ui/core";
// import { Alert, AlertTitle } from '@material-ui/lab';
import AlertStyles from "../../assets/jss/Alerts";
// @material-ui/icons
import Check from "@material-ui/icons/Check";
import Warning from "@material-ui/icons/Warning";

import SnackbarContent from "components/MaterialKit/Snackbar/SnackbarContent";

const useStyles = makeStyles(AlertStyles);

const MyAlert = (props) => {
  const { alerts } = useSelector((state) => {
    return {
      alerts: state.alert,
    };
  }, shallowEqual);
  const classes = useStyles();

  const getIcon = (alert) => {
    console.log(alert.alertType);
    switch (alert.alertType) {
      case "success":
        return Check;
      case "danger":
      case "info":
        return "info_outline";
      case "warning":
        return Warning;
      default:
        return "info_outline";
    }
  };

  return (
    alerts !== null &&
    alerts.length > 0 &&
    alerts.map((alert) => {
      console.log(alert);
      return (
        <SnackbarContent
          className={classes.root}
          key={alert.id}
          open={alert.msg.length > 0 ? true : false}
          message={
            <span>
              <b>{alert.msg}</b>
            </span>
          }
          close
          color={alert.alertType}
          icon={getIcon(alert)}
        />
      );
    })
  );
};

export default MyAlert;
